<div class="modal-content">
  <div class="modal-header">
    <div class="modal-title center-fields">
      <app-page-cardhead style="margin-top: -1.1rem;" [PageName]="getPageName()"
        [PageHeadWidth]=500></app-page-cardhead>
    </div>
  </div>

  <div class="modal-body">
    <!-- Loan Details Display -->
    <div class="loan-details mb-4">
      <h6 class="border-bottom pb-2">Loan Details</h6>
      <table class="table table-sm">
        <tbody>
          <tr *ngIf="quoteData">
            <td><strong>Client Name:</strong></td>
            <td>{{ quoteData.firstName }} {{ quoteData.lastName }}</td>
          </tr>
          <tr *ngIf="quoteData">
            <td><strong>ID Number:</strong></td>
            <td>{{ quoteData.idNumber }}</td>
          </tr>
          <tr>
            <td><strong>Loan Amount:</strong></td>
            <td>R {{ loanAmount | number: '1.2-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Client Type Warning -->
    <div *ngIf="clientType === 'pensioner'" class="alert alert-info mb-3">
      <strong>Pensioner Loan:</strong> Regional Manager approval is required for this loan.
    </div>

    <!-- Approval Type Selection -->
    <div class="approval-selection mb-4">
      <h6 class="border-bottom pb-2">Approval Required</h6>

      <div class="form-check mb-3" *ngIf="clientType === 'salaried'">
        <input
          class="form-check-input"
          type="radio"
          id="bmApproval"
          [value]="'BM'"
          [(ngModel)]="selectedApprovalType">
        <label class="form-check-label" for="bmApproval">
          <strong>Branch Manager Approval</strong>
          <small class="text-muted d-block">Biometric verification required</small>
        </label>
      </div>

      <div class="form-check mb-3" *ngIf="clientType === 'salaried'">
        <input
          class="form-check-input"
          type="radio"
          id="amApproval"
          [value]="'AM'"
          [(ngModel)]="selectedApprovalType">
        <label class="form-check-label" for="amApproval">
          <strong>Area Manager Approval</strong>
          <small class="text-muted d-block">Request will be sent to Area Manager for review</small>
        </label>
      </div>

      <div class="form-check mb-3" *ngIf="clientType === 'pensioner'">
        <input
          class="form-check-input"
          type="radio"
          id="rmApproval"
          [value]="'RM'"
          [(ngModel)]="selectedApprovalType"
          checked>
        <label class="form-check-label" for="rmApproval">
          <strong>Regional Manager Approval</strong>
          <small class="text-muted d-block">RM approval email upload will be required</small>
        </label>
      </div>
    </div>

    <!-- Info Message -->
    <div *ngIf="selectedApprovalType" class="alert alert-info mt-3">
      <p *ngIf="selectedApprovalType === 'AM'" class="mb-0">
        <strong>Area Manager Approval:</strong> Your approval request will be sent to the Area Manager. You will be able to continue once approved.
      </p>
      <p *ngIf="selectedApprovalType === 'RM'" class="mb-0">
        <strong>Regional Manager Approval:</strong> Your approval request will be sent to the Regional Manager. A document upload is required to proceed.
      </p>
      <p *ngIf="selectedApprovalType === 'BM'" class="mb-0">
        <strong>Branch Manager Approval:</strong> Biometric verification will be performed to authorize this LT loan.
      </p>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-between">
    <button class="btn btn-secondary btn-sm" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button
      class="btn btn-primary btn-sm"
      type="button"
      (click)="onSubmit()"
      [disabled]="!selectedApprovalType || isProcessing">
      <span *ngIf="!isProcessing">Submit</span>
      <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      <span *ngIf="isProcessing">Processing...</span>
    </button>
  </div>
</div>
